export default {
  actionIcon: 'StarIcon',
  highlightColor: 'warning',
  data: [
    {index: 0, label: 'Dashboard',             url: '/',                        labelIcon: 'HomeIcon',     highlightAction: false},
    {index: 1, label: 'Student',  url: '/Student',  labelIcon: 'UserIcon',     highlightAction: false},
    {index: 2, label: 'Leads', url: '/Leads', labelIcon: 'UsersIcon',     highlightAction: false},
    {index: 4, label: 'Profile',         url: '/Profile',        labelIcon: 'UserIcon',     highlightAction: false},
    {index: 5, label: 'Email',    labelIcon: 'MailIcon',     highlightAction: true},
    {index: 6, label: 'Task',       labelIcon: 'CheckSquareIcon',     highlightAction: true},
    {index: 7, label: 'Chat',                      labelIcon: 'MessageSquareIcon',    highlightAction: true},
    {index: 8, label: 'Calendar',  labelIcon: 'CalendarIcon',    highlightAction: true},
  ]
}
